import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import Modal from "react-bootstrap/Modal";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  deleteEvent,
  getEventDetail,
  getEventReqSongs,
  getEventSongs,
  unlockChoice,
  updateSongRequest,
} from "../Redux/Actions/event";
import { Decryptedid } from "../Utils/bcrypt";
import {
  capitalize,
  formatDateToDMY,
  formatEventDetails,
  genreOptions,
  getDueDate,
} from "../Utils/commonFiles";
import PaginationComponent from "../Components/Pagination";
import { Dropdown } from "react-bootstrap";
import CreateEventModal from "../Components/CommanModals/CreateEventModal";
import DeleteModal from "../Components/CommanModals/DeleteModal";
import { toast } from "react-toastify";
import AdminActions from "../Redux/Actions/AdminActions";
import { updateClient } from "../Redux/Actions/auth";

export default function EventsDetails() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const Id = id && Decryptedid(atob(id));
  const navigate = useNavigate();

  const eventData = useSelector((e) => e.eventAuth.eventDetail);

  const requestedSongs = useSelector((e) => e.eventAuth.requestedSongs);
  const eventSongs = useSelector((e) => e.eventAuth.eventSongs);
  const { formattedDate, formattedTime } = formatEventDetails(
    eventData?.eventDate,
    eventData?.eventTime
  );

  const eventTypeNames = Array.isArray(eventData?.eventType)
    ? eventData.eventType.map((et) => et?.eventType).filter(Boolean).join(", ")
    : eventData?.eventType?.eventType || "";
  const eventTypeLabel = eventData?.eventPackage?.name
    ? `${eventData.eventPackage.name}${eventTypeNames ? ` (${eventTypeNames})` : ""}`
    : eventTypeNames;

  const [show, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [eventCurrPage, setEventCurrPage] = useState(0);
  const handleClose = () => setShow(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isCheckToggle, setIsCheckToggle] = useState({});
  const [flag, setFlag] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [isEditingNotes, setIsEditingNotes] = useState(false);
  const [notesDraft, setNotesDraft] = useState("");
  const eventNotes = eventData?.client?.notes || "";

  const totalEntries = requestedSongs?.total ?? 0;
  const entriesPerPage = 5;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const songsTotalEntries = eventSongs?.total ?? 0;
  const songsEntriesPerPage = 11;
  const songsTotalPages = Math.ceil(totalEntries / entriesPerPage);

  const handleOpen = () => setShowModal(true);
  const handleCloseEvent = () => setShowModal(false);
  const handleOpenDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  const handleOpenNotesModal = () => {
    setNotesDraft(eventNotes);
    setIsEditingNotes(false);
    setShowNotesModal(true);
  };
  const handleCloseNotesModal = () => {
    setShowNotesModal(false);
    setIsEditingNotes(false);
    setNotesDraft(eventNotes);
  };

  const handlePageChange = (page) => setCurrentPage(page);
  const handlePageChangeSongs = (page) => setEventCurrPage(page);

  const handleDeleteEvent = () => {
    dispatch(deleteEvent({ id: eventData._id })).then((res) => {
      if (res?.payload?.statusCode == 200) {
        toast.success("Deleted Successfully");
        navigate(-1);
      } else {
        toast.error(res?.payload?.message);
      }
      handleCloseDeleteModal();
    });
  };

  const handleUnlockChoice = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const clientId = urlParams.get("clientId")
    dispatch(unlockChoice({ islocked: false, clientId })).then((res) => {
      if (res?.payload?.statusCode == 200) {
        Initialize()
      } else {
        toast.error(res?.payload?.message);
      }
      // handleCloseDeleteModal();
    });
  };

  const handleRequestAction = async (value, res) => {
    if (!value) return;
    try {
      let data = {
        songId: res._id,
        clientId: res.clientRequest.client._id,
        event: res.clientRequest.event._id,
        section: res.clientRequest.section,
        status: value,
      };
      await dispatch(updateSongRequest(data)).then(() => Initialize());
    } catch (error) { }
  };

  // const Initialize = async () => {
  //   try {
  //     const urlParams = new URLSearchParams(window.location.search);
  //     const clientId = urlParams.get("clientId");
  //     dispatch(startstopLoading(true));
  //     await dispatch(getEventDetail({ id: Id })).then(async (res) => {
  //       await dispatch(getEventReqSongs({ limit: 5, page: currentPage, clientId, eventId: Id }));
  //       await dispatch(getEventSongs({ limit: 10, page: eventCurrPage, eventId: Id }));
  //       dispatch(startstopLoading(false));
  //     });
  //   } catch (error) { }
  // };

  // useEffect(() => {
  //   Initialize();
  // }, [currentPage, eventCurrPage]);

  // const handleChange = async (res) => {
  //   const newStatus = isCheckToggle[res._id] ? "Rejected" : "Approved";

  //   let data = {
  //     songId: res._id,
  //     clientId: res.clientRequest.client._id,
  //     event: res.clientRequest.event._id,
  //     section: res.clientRequest.section,
  //     status: newStatus,
  //   };

  //   setIsCheckToggle((prevState) => ({
  //     ...prevState,
  //     [res._id]: !prevState[res._id],
  //   }));

  //   try {
  //     await dispatch(updateSongRequest(data)).then((res) => {
  //       if (res?.payload?.statusCode === 200) {
  //         Initialize();
  //       } else {
  //         setIsCheckToggle((prevState) => ({
  //           ...prevState,
  //           [res._id]: !prevState[res._id],
  //         }));
  //         toast.error(res?.payload?.message || "Failed to update song status");
  //       }
  //     });
  //   } catch (error) {
  //     setIsCheckToggle((prevState) => ({
  //       ...prevState,
  //       [res._id]: !prevState[res._id],
  //     }));
  //     toast.error("An error occurred while updating song status");
  //     console.error(error);
  //   }
  // };

  const handleChange = async (res, newStatus) => {
    if (!newStatus) return;

    let data = {
      songId: res._id,
      clientId: res.clientRequest.client._id,
      event: res.clientRequest.event._id,
      section: res.clientRequest.section?._id,
      status: newStatus,
    };

    try {
      const response = await dispatch(updateSongRequest(data));
      if (response?.payload?.statusCode === 200) {
        toast.success("Song status updated");
        Initialize();
      } else {
        toast.error(
          response?.payload?.message || "Failed to update song status"
        );
      }
    } catch (error) {
      toast.error("An error occurred while updating song status");
      console.error(error);
    }
  };

  const Initialize = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const clientId = urlParams.get("clientId");
      dispatch(startstopLoading(true));
      await Promise.all([
        dispatch(getEventDetail({ id: Id })),
        dispatch(
          getEventReqSongs({
            limit: 50,
            page: currentPage,
            clientId: clientId,
            eventId: Id,
          })
        ),
        dispatch(
          getEventSongs({ limit: 50, page: eventCurrPage, eventId: Id })
        ),
      ]);
      dispatch(startstopLoading(false));
    } catch (error) {
      dispatch(startstopLoading(false));
      toast.error("Failed to load event data");
      console.error(error);
    }
  };

  useEffect(() => {
    if (requestedSongs?.songs?.length > 0) {
      setIsCheckToggle(
        requestedSongs.songs.reduce((acc, item) => {
          acc[item._id] = item.requestedSongStatus === "Approved";
          return acc;
        }, {})
      );
    }
  }, [requestedSongs]);

  useEffect(() => {
    setNotesDraft(eventNotes);
  }, [eventNotes]);

  useEffect(() => {
    Initialize();
  }, [currentPage, eventCurrPage]);

  const handleChangeStatus = (id, val) => {
    dispatch(AdminActions.updateTransactionStatus({ id, status: val })).then(
      (res) => {
        Initialize();
        setFlag(!flag);
      }
    );
  };

  const getDueDate1 = (eventDate, amount) => {
    if (amount === 100) {
      const eventDateObj = new Date(eventDate?.createdAt);
      const dueDate = new Date(eventDateObj);
      return dueDate;
    } else {
      const eventDateObj = new Date(eventDate?.eventDate);
      const dueDate = new Date(eventDateObj);
      dueDate.setDate(eventDateObj.getDate() - 7);
      return dueDate;
    }
  };

  const handleSaveNotes = () => {
    const clientId = eventData?.client?._id;
    if (!clientId) {
      toast.error("Client data is not available yet");
      return;
    }

    const payload = {
      id: clientId,
      fullName: eventData?.client?.fullName,
      notes: notesDraft,
    };

    dispatch(updateClient(payload)).then((res) => {
      if (res?.payload?.statusCode === 200) {
        toast.success("Notes Updated Successfully");
        dispatch(getEventDetail({ id: eventData?._id }));
        setIsEditingNotes(false);
      } else {
        toast.error(res?.payload?.message || "Failed to update notes");
      }
    });
  };


  return (
    <Layout>
      <Container fluid>
        <Row>
          <Col lg={12}>
            <div className="detail-view-card  mt-3">
              <div className="detail-pro-img">
                <img
                  src={require("../../src/Assets/Images/user-placeholder.png")}
                />
              </div>
              <div className="detail-pro-name">
                <h2>{capitalize(eventData?.client?.fullName)}</h2>
                <p>{formattedDate}</p>
                <p>{formattedTime}</p>
              </div>
              <div className="detail-pro-edition">
                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_114_6746)">
                      <path
                        d="M8.99903 5C8.40568 5 7.82566 5.17595 7.33231 5.50559C6.83897 5.83524 6.45445 6.30377 6.22739 6.85195C6.00032 7.40013 5.94091 8.00333 6.05667 8.58527C6.17242 9.16721 6.45815 9.70176 6.8777 10.1213C7.29726 10.5409 7.83181 10.8266 8.41375 10.9424C8.9957 11.0581 9.5989 10.9987 10.1471 10.7716C10.6953 10.5446 11.1638 10.1601 11.4934 9.66671C11.8231 9.17336 11.999 8.59334 11.999 8C11.999 7.20435 11.683 6.44129 11.1203 5.87868C10.5577 5.31607 9.79468 5 8.99903 5ZM8.99903 9.5C8.70235 9.5 8.41234 9.41203 8.16567 9.2472C7.919 9.08238 7.72674 8.84811 7.61321 8.57403C7.49967 8.29994 7.46997 7.99834 7.52785 7.70736C7.58572 7.41639 7.72859 7.14912 7.93837 6.93934C8.14814 6.72956 8.41542 6.5867 8.70639 6.52882C8.99736 6.47094 9.29896 6.50065 9.57305 6.61418C9.84714 6.72771 10.0814 6.91997 10.2462 7.16665C10.4111 7.41332 10.499 7.70333 10.499 8C10.499 8.39783 10.341 8.77936 10.0597 9.06066C9.77838 9.34196 9.39685 9.5 8.99903 9.5Z"
                        fill="#979699"
                      />
                      <path
                        d="M8.99926 18.5C8.36772 18.5033 7.74459 18.3551 7.18206 18.0681C6.61952 17.781 6.13396 17.3633 5.76601 16.85C2.90776 12.9073 1.45801 9.94328 1.45801 8.03979C1.45801 6.03972 2.25253 4.12157 3.66679 2.70732C5.08105 1.29306 6.99919 0.498535 8.99926 0.498535C10.9993 0.498535 12.9175 1.29306 14.3317 2.70732C15.746 4.12157 16.5405 6.03972 16.5405 8.03979C16.5405 9.94328 15.0908 12.9073 12.2325 16.85C11.8646 17.3633 11.379 17.781 10.8165 18.0681C10.2539 18.3551 9.6308 18.5033 8.99926 18.5ZM8.99926 2.13579C7.43357 2.13757 5.93252 2.76033 4.82541 3.86744C3.7183 4.97455 3.09554 6.4756 3.09376 8.04129C3.09376 9.54879 4.51351 12.3365 7.09051 15.8908C7.30928 16.1921 7.59629 16.4374 7.92804 16.6065C8.2598 16.7756 8.62688 16.8638 8.99926 16.8638C9.37163 16.8638 9.73872 16.7756 10.0705 16.6065C10.4022 16.4374 10.6892 16.1921 10.908 15.8908C13.485 12.3365 14.9048 9.54879 14.9048 8.04129C14.903 6.4756 14.2802 4.97455 13.1731 3.86744C12.066 2.76033 10.5649 2.13757 8.99926 2.13579Z"
                        fill="#979699"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_114_6746">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                  Venue: <span>{eventData?.location}</span>
                </p>
                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M20.59 13.41L11.42 4.24C11.05 3.87 10.55 3.66 10.02 3.66H5C3.9 3.66 3 4.56 3 5.66V10.68C3 11.21 3.21 11.71 3.58 12.08L12.75 21.25C13.13 21.63 13.65 21.84 14.19 21.84C14.73 21.84 15.25 21.63 15.63 21.25L20.59 16.29C20.97 15.91 21.18 15.39 21.18 14.85C21.18 14.31 20.97 13.79 20.59 13.41Z"
                      stroke="#979699"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M7.5 8.5C8.05228 8.5 8.5 8.05228 8.5 7.5C8.5 6.94772 8.05228 6.5 7.5 6.5C6.94772 6.5 6.5 6.94772 6.5 7.5C6.5 8.05228 6.94772 8.5 7.5 8.5Z"
                      fill="#979699"
                    />
                  </svg>{" "}
                  Event Type: <span>{eventTypeLabel || "N/A"}</span>
                </p>
                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_114_6753)">
                      <path
                        d="M17.7583 1.80284C17.828 1.73321 17.8832 1.65054 17.9209 1.55956C17.9586 1.46858 17.978 1.37107 17.978 1.27259C17.978 1.17412 17.9586 1.0766 17.9209 0.985623C17.8832 0.894642 17.828 0.811975 17.7583 0.742342C17.6887 0.672708 17.606 0.617472 17.5151 0.579787C17.4241 0.542101 17.3266 0.522705 17.2281 0.522705C17.1296 0.522705 17.0321 0.542101 16.9411 0.579787C16.8501 0.617472 16.7675 0.672708 16.6978 0.742342L12.9298 4.51034C12.062 3.86411 11.0111 3.51083 9.92916 3.50166C8.84723 3.49249 7.79045 3.82791 6.91183 4.45934C6.63541 4.6466 6.4117 4.90169 6.26212 5.20018C6.11255 5.49868 6.04212 5.83058 6.05758 6.16409C6.08758 6.71009 5.77333 7.18409 5.12533 7.57334C4.49683 7.95059 3.92308 8.04659 3.42433 7.86209C3.02295 7.71365 2.58388 7.70137 2.17483 7.82715C1.76578 7.95293 1.40947 8.20978 1.16083 8.55809C0.296531 9.76916 -0.109462 11.2479 0.0152685 12.7305C0.139999 14.2131 0.78734 15.6032 1.84183 16.6528C2.89109 17.7076 4.28098 18.3553 5.76351 18.4803C7.24604 18.6053 8.72476 18.1995 9.93583 17.3353C10.285 17.0869 10.5425 16.7302 10.6683 16.3206C10.7942 15.9109 10.7813 15.4712 10.6318 15.0696C10.4451 14.5686 10.5411 13.9948 10.9183 13.3671C11.3076 12.7191 11.7951 12.4033 12.3291 12.4371C12.6633 12.4548 12.9963 12.3854 13.2956 12.2358C13.595 12.0862 13.8504 11.8615 14.0368 11.5836C14.6675 10.7059 15.0027 9.65038 14.994 8.56963C14.9852 7.48888 14.6329 6.43892 13.9881 5.57159L17.7576 1.80209L17.7583 1.80284ZM12.7986 10.7398C12.7557 10.802 12.6983 10.8527 12.6314 10.8876C12.5645 10.9225 12.4901 10.9405 12.4146 10.9401C11.7651 10.9033 10.5486 11.0698 9.63283 12.5961C8.85658 13.8906 8.98408 14.9413 9.22708 15.5946C9.26179 15.6864 9.26509 15.7872 9.23646 15.8811C9.20783 15.975 9.14888 16.0568 9.06883 16.1136C8.25207 16.6949 7.27302 17.0044 6.27051 16.9981C5.26801 16.9917 4.29294 16.6699 3.48358 16.0783L4.28083 15.2811C4.35047 15.2115 4.4057 15.1288 4.44339 15.0378C4.48107 14.9468 4.50047 14.8493 4.50047 14.7508C4.50047 14.6524 4.48107 14.5549 4.44339 14.4639C4.4057 14.3729 4.35047 14.2902 4.28083 14.2206C4.2112 14.151 4.12853 14.0957 4.03755 14.058C3.94657 14.0204 3.84906 14.001 3.75058 14.001C3.65211 14.001 3.55459 14.0204 3.46361 14.058C3.37263 14.0957 3.28997 14.151 3.22033 14.2206L2.42233 15.0186C1.82875 14.2089 1.50561 13.2326 1.49888 12.2287C1.49215 11.2247 1.80216 10.2442 2.38483 9.42659C2.44174 9.34684 2.52342 9.28815 2.61716 9.25966C2.7109 9.23117 2.81142 9.23449 2.90308 9.26909C3.55408 9.51134 4.60333 9.63659 5.89708 8.86034C7.42183 7.94459 7.59058 6.72659 7.55458 6.08234C7.54708 5.93609 7.62358 5.78909 7.78408 5.67959C8.37412 5.25496 9.07873 5.01857 9.80548 5.00144C10.5322 4.98431 11.2472 5.18723 11.8566 5.58359L7.72033 9.71984C7.6507 9.78948 7.59546 9.87214 7.55778 9.96312C7.52009 10.0541 7.5007 10.1516 7.5007 10.2501C7.50069 10.3486 7.52009 10.4461 7.55778 10.5371C7.59546 10.628 7.6507 10.7107 7.72033 10.7803C7.78997 10.85 7.87263 10.9052 7.96361 10.9429C8.05459 10.9806 8.15211 11 8.25058 11C8.34906 11 8.44657 10.9806 8.53755 10.9429C8.62853 10.9052 8.7112 10.85 8.78083 10.7803L12.9148 6.64634C13.7068 7.86959 13.6986 9.47909 12.7986 10.7398ZM12.7281 1.64834C12.7281 1.50056 12.7573 1.35423 12.8139 1.21771C12.8705 1.08119 12.9534 0.957157 13.058 0.852691C13.1625 0.748225 13.2866 0.665372 13.4231 0.608862C13.5597 0.552352 13.706 0.523293 13.8538 0.523342C14.0016 0.523391 14.1479 0.552548 14.2845 0.609149C14.421 0.66575 14.545 0.748686 14.6495 0.853222C14.7539 0.957757 14.8368 1.08185 14.8933 1.2184C14.9498 1.35496 14.9789 1.50131 14.9788 1.64909C14.9787 1.94756 14.8601 2.23376 14.649 2.44474C14.4378 2.65572 14.1516 2.77419 13.8531 2.77409C13.5546 2.77399 13.2684 2.65533 13.0574 2.44421C12.8465 2.23309 12.728 1.94681 12.7281 1.64834ZM17.9781 4.64834C17.978 4.94681 17.8593 5.23301 17.6482 5.44399C17.4371 5.65497 17.1508 5.77344 16.8523 5.77334C16.5539 5.77324 16.2677 5.65458 16.0567 5.44346C15.8457 5.23234 15.7272 4.94606 15.7273 4.64759C15.7274 4.34912 15.8461 4.06292 16.0572 3.85194C16.2683 3.64096 16.5546 3.52249 16.8531 3.52259C17.1516 3.52269 17.4378 3.64135 17.6487 3.85247C17.8597 4.06359 17.9782 4.34987 17.9781 4.64834ZM7.28083 12.7206C7.35047 12.7902 7.4057 12.8729 7.44339 12.9639C7.48107 13.0549 7.50047 13.1524 7.50047 13.2508C7.50047 13.3493 7.48107 13.4468 7.44339 13.5378C7.4057 13.6288 7.35047 13.7115 7.28083 13.7811C7.2112 13.8507 7.12853 13.906 7.03755 13.9436C6.94657 13.9813 6.84906 14.0007 6.75058 14.0007C6.65211 14.0007 6.55459 13.9813 6.46361 13.9436C6.37263 13.906 6.28997 13.8507 6.22033 13.7811L4.72033 12.2811C4.6507 12.2115 4.59546 12.1288 4.55778 12.0378C4.52009 11.9468 4.5007 11.8493 4.5007 11.7508C4.5007 11.6524 4.52009 11.5549 4.55778 11.4639C4.59546 11.3729 4.6507 11.2902 4.72033 11.2206C4.78997 11.151 4.87263 11.0957 4.96361 11.058C5.05459 11.0204 5.15211 11.001 5.25058 11.001C5.34906 11.001 5.44657 11.0204 5.53755 11.058C5.62853 11.0957 5.7112 11.151 5.78083 11.2206L7.28083 12.7206Z"
                        fill="#979699"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_114_6753">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                  Musician: <span>{eventData?.musician?.fullName}</span>
                </p>
                <p style={{ display: 'flex', gap: '6px' }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <text
                      x="0"
                      y="16"
                      font-family="Arial"
                      font-size="18"
                      fill="#979699"
                    >
                      £
                    </text>
                  </svg>
                  Price: <span>£{eventData?.price}</span>
                  {eventData?.isDiscounted ? <div style={{ height: '9px', width: '9px', backgroundColor: 'green', borderRadius: '100px', }}></div> : ''}
                </p>
                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_114_6759)">
                      <circle
                        cx="9"
                        cy="9"
                        r="7"
                        fill="none"
                        stroke="#979699"
                        strokeWidth="1"
                      />
                      <path
                        d="M9 2C10.1046 2 11 2.89543 11 4V5C11 5.10457 10.8954 5.2 10.7901 5.2H7.20985C7.10457 5.2 7 5.10457 7 5V4C7 2.89543 7.89543 2 9 2Z"
                        fill="#979699"
                      />
                      <line
                        x1="9"
                        y1="0"
                        x2="9"
                        y2="19"
                        stroke="#979699"
                        strokeWidth="1"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_114_6759">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                  Booking Reference:{" "}
                  <span>{eventData?.reference || "N/A"}</span>
                </p>
                {/* <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_114_6759)">
                      <circle
                        cx="9"
                        cy="9"
                        r="7"
                        fill="none"
                        stroke="#979699"
                        strokeWidth="1"
                      />
                      <path
                        d="M9 2C10.1046 2 11 2.89543 11 4V5C11 5.10457 10.8954 5.2 10.7901 5.2H7.20985C7.10457 5.2 7 5.10457 7 5V4C7 2.89543 7.89543 2 9 2Z"
                        fill="#979699"
                      />
                      <line
                        x1="9"
                        y1="0"
                        x2="9"
                        y2="19"
                        stroke="#979699"
                        strokeWidth="1"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_114_6759">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                  Songs Confirmed:{" "}
                  <span>{eventData?.islocked ? 'Yes' : "No"}</span>
                </p> */}
                {/* <p style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  {eventData?.islocked ? (
                    // ✅ Confirmed (Yes)
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="19"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="#979699"
                        strokeWidth="2"
                        fill="none"
                      />
                      <path
                        d="M7 12.5L10.5 16L17 8"
                        stroke="#979699"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    // ❌ Not Confirmed (No)
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="19"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="#979699"
                        strokeWidth="2"
                        fill="none"
                      />
                      <line
                        x1="8"
                        y1="8"
                        x2="16"
                        y2="16"
                        stroke="#979699"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                      <line
                        x1="16"
                        y1="8"
                        x2="8"
                        y2="16"
                        stroke="#979699"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  )}
                  Songs Confirmed:{" "}
                  <span style={{ fontWeight: 500 }}>
                    {eventData?.islocked ? "Yes" : "No"}
                  </span>
                </p> */}
                <p style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="#979699"
                      strokeWidth="2"
                      fill="none"
                    />
                    <path
                      d="M7 12.5L10.5 16L17 8"
                      stroke="#979699"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Songs Confirmed:{" "}
                  <span style={{ fontWeight: 500 }}>
                    {eventData?.client?.islocked ? "Yes" : "No"}
                  </span>
                </p>

              </div>
              {/* <div className="detail-pro-name event-details-text">
                <p>
                   Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation 
                </p>
              </div> */}
              <Dropdown className="dots-dropdown">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <div className="drop-pro-view">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      style={{ cursor: "pointer" }}
                    >
                      <g opacity="0.8">
                        <path
                          d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                          stroke="#132027"
                          strokeWidth="2"
                          strokeLinecap="square"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                          stroke="#132027"
                          strokeWidth="2"
                          strokeLinecap="square"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                          stroke="#132027"
                          strokeWidth="2"
                          strokeLinecap="square"
                          strokeLinejoin="round"
                        />
                      </g>
                    </svg>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <div className="my-profile" onClick={handleOpen}>
                    <Dropdown.Item>Edit</Dropdown.Item>
                  </div>

                  <div className="my-profile" onClick={handleOpenDeleteModal}>
                    <Dropdown.Item> Delete</Dropdown.Item>
                  </div>
                  {eventData?.client?.islocked && <div className="my-profile" onClick={handleUnlockChoice}>
                    <Dropdown.Item>Unlock song choices</Dropdown.Item>
                  </div>}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
          <Col lg={8}>
            <div className="comn-table-title">
              <h3>
                Song list <span>({eventSongs?.total})</span>
              </h3>
            </div>
            <div className="filters">
              <div className="inner-filter-field">
                <div class="table-responsive" style={{ maxHeight: '300px', overflowY: 'scroll' }}>
                  <Table size="sm" className="table-cmn">
                    <thead style={{ position: 'sticky', top: '0px' }}>
                      <tr>
                        <th>
                          <div className="user-checkbox">Song name</div>
                        </th>
                        <th>Artist</th>
                        <th>Genre</th>
                        <th>Section</th>
                      </tr>
                    </thead>
                    <tbody>
                      {eventSongs?.songs?.map((songsRes) => (
                        <tr>
                          <td>
                            <div className="first-user">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                              >
                                <path
                                  d="M25 10.6667V25.3333C25 25.5986 24.8946 25.8529 24.7071 26.0404C24.5196 26.228 24.2652 26.3333 24 26.3333C23.7348 26.3333 23.4804 26.228 23.2929 26.0404C23.1054 25.8529 23 25.5986 23 25.3333V10.6667C23 10.4015 23.1054 10.1471 23.2929 9.95956C23.4804 9.77202 23.7348 9.66667 24 9.66667C24.2652 9.66667 24.5196 9.77202 24.7071 9.95956C24.8946 10.1471 25 10.4015 25 10.6667ZM20 6C19.7348 6 19.4804 6.10536 19.2929 6.29289C19.1054 6.48043 19 6.73478 19 7V29C19 29.2652 19.1054 29.5196 19.2929 29.7071C19.4804 29.8946 19.7348 30 20 30C20.2652 30 20.5196 29.8946 20.7071 29.7071C20.8946 29.5196 21 29.2652 21 29V7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM28 13.3333C27.7348 13.3333 27.4804 13.4387 27.2929 13.6262C27.1054 13.8138 27 14.0681 27 14.3333V21C27 21.2652 27.1054 21.5196 27.2929 21.7071C27.4804 21.8946 27.7348 22 28 22C28.2652 22 28.5196 21.8946 28.7071 21.7071C28.8946 21.5196 29 21.2652 29 21V14.3333C29 14.0681 28.8946 13.8138 28.7071 13.6262C28.5196 13.4387 28.2652 13.3333 28 13.3333ZM16 10C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11V25C15 25.2652 15.1054 25.5196 15.2929 25.7071C15.4804 25.8946 15.7348 26 16 26C16.2652 26 16.5196 25.8946 16.7071 25.7071C16.8946 25.5196 17 25.2652 17 25V11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10ZM12 13C11.7348 13 11.4804 13.1054 11.2929 13.2929C11.1054 13.4804 11 13.7348 11 14V22C11 22.2652 11.1054 22.5196 11.2929 22.7071C11.4804 22.8946 11.7348 23 12 23C12.2652 23 12.5196 22.8946 12.7071 22.7071C12.8946 22.5196 13 22.2652 13 22V14C13 13.7348 12.8946 13.4804 12.7071 13.2929C12.5196 13.1054 12.2652 13 12 13ZM8 15C7.73478 15 7.48043 15.1054 7.29289 15.2929C7.10536 15.4804 7 15.7348 7 16V20C7 20.2652 7.10536 20.5196 7.29289 20.7071C7.48043 20.8946 7.73478 21 8 21C8.26522 21 8.51957 20.8946 8.70711 20.7071C8.89464 20.5196 9 20.2652 9 20V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15Z"
                                  fill="#979699"
                                />
                              </svg>
                              <div className="user-profile">
                                {capitalize(songsRes?.title)}
                              </div>
                            </div>
                          </td>
                          <td>{capitalize(songsRes?.artist)}</td>
                          <td>{genreOptions[songsRes?.genre] || "-"}</td>
                          <td>{songsRes?.sectionName}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {eventSongs?.songs?.length == 0 && (
                    <div className="song-requests-data">
                      <div className="no-data-found">
                        <p>No Data</p>
                      </div>
                    </div>
                  )}
                  {/* {eventSongs?.total > 1 && (
                    <PaginationComponent
                      currentPage={eventCurrPage}
                      totalPages={songsTotalPages}
                      onPageChange={handlePageChangeSongs}
                      totalEntries={songsTotalEntries}
                      entriesPerPage={songsEntriesPerPage}
                    />
                  )} */}
                </div>
              </div>
            </div>
          </Col>

          <Col lg={4}>
            <div className="comn-table-title">
              <h3>Payment history</h3>
            </div>
            <div className="filters">
              <div className="inner-filter-field" style={{ height: '300px', maxHeight: '300px', overflowY: 'scroll' }}>
                <div class="table-responsive">
                  <Table size="sm" className="table-cmn">
                    <thead>
                      <tr>
                        <th>
                          <div className="user-checkbox">Date</div>
                        </th>
                        {/* <th>Booking Fee</th>
                        <th>Other Expense</th> */}
                        <th>Amount</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {eventData?.payment?.map((paymentRes) => (
                        <tr>
                          <td>
                            <div className="first-user">
                              <div className="user-profile">
                                {formatDateToDMY(getDueDate(eventData?.eventDate))}
                              </div>
                            </div>
                          </td>
                          <td>£{paymentRes?.amount}</td>
                          <td>
                          <div className="mb-3">
                            <select
                              id="category"
                              value={paymentRes?.status}
                              onChange={(e) =>
                                handleChangeStatus(paymentRes?._id, e.target.value)
                              }
                              className={`form-control ${paymentRes?.status === "Overdue" ||
                                  paymentRes?.status === "Pending" ||
                                  paymentRes?.status === "Pending"
                                  ? "me-4"
                                  : ""
                                } custom-select`}
                            >
                              <option disabled>Select</option>
                              <option value="Pending">Pending</option>
                              <option value="Complete">Complete</option>
                              <option value="Overdue">Overdue</option>
                            </select>
                          </div>
                        </td>
                        </tr>
                      ))} */}

                      {eventData?.payment?.map((paymentRes) => (
                        <tr key={paymentRes._id}>
                          {/* Date */}
                          <td>
                            <div className="first-user">
                              <div className="user-profile">
                                {formatDateToDMY(
                                  getDueDate1(eventData, paymentRes?.amount)
                                )}
                              </div>
                            </div>
                          </td>

                          <td>£{paymentRes?.amount}</td>

                          {/* <tr>
                           <td>£{paymentRes?.bookingfee}</td>
                          <td>£{paymentRes?.otherExpense}</td>
                         </tr> */}

                          {/* Status */}
                          <td>
                            <div className="mb-2">
                              <select
                                id="category"
                                value={paymentRes?.status}
                                onChange={(e) =>
                                  handleChangeStatus(
                                    paymentRes?._id,
                                    e.target.value
                                  )
                                }
                                className={`form-control ${paymentRes?.status === "Overdue" ||
                                  paymentRes?.status === "Pending"
                                  ? "me-4"
                                  : ""
                                  } custom-select`}
                              >
                                {/* <option disabled>Select</option>
                                <option value="Pending">Pending</option>
                                <option value="Complete">Complete</option>
                                <option value="Overdue">Overdue</option> */}
                                <option disabled>Select</option>
                                <option value="Pending" className="">
                                  Pending
                                </option>
                                <option
                                  value="Complete"
                                  className="option-complete"
                                >
                                  Complete
                                </option>
                                <option
                                  value="Overdue"
                                  className="option-overdue"
                                >
                                  Overdue
                                </option>
                                <option
                                  value="ClientPaid"
                                  className="option-payment-done"
                                >
                                  Awaiting Confirmation
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {eventData?.payment?.length == 0 && (
                    <div className="song-requests-data">
                      <div className="no-data-found">
                        <p>No Data</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <div className="comn-table-title">
              <h3>Song Requests</h3>
            </div>
            <div className="filters">
              <div className="inner-filter-field" style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                <div class="table-responsive">
                  <Table size="sm" className="table-cmn">
                    <thead>
                      <tr>
                        <th>
                          <div className="user-checkbox">Package</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Client Name</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Venue Date</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Song Title</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Artist</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Section</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Link</div>
                        </th>
                        <th>
                          <div className="user-checkbox">comments</div>
                        </th>

                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requestedSongs?.songs?.map((requestedSongsRes) => (
                        <tr>
                          <td>
                            <div className="first-user">
                              <div className="user-profile">
                                {capitalize(
                                  requestedSongsRes?.clientRequest?.event
                                    ?.eventName
                                )}
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="first-user">
                              <div className="user-profile">
                                {
                                  requestedSongsRes?.clientRequest?.client
                                    ?.fullName
                                }
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="first-user">
                              <div className="user-profile">
                                {formatDateToDMY(
                                  requestedSongsRes?.clientRequest?.event
                                    ?.eventDate
                                )}
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="first-user">
                              <div className="user-profile">
                                {requestedSongsRes?.title}
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="first-user">
                              <div className="user-profile">
                                {requestedSongsRes?.artist}
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="first-user">
                              <div className="user-profile">
                                {requestedSongsRes?.clientRequest?.section
                                  ?.sectionName}
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="first-user">
                              <div className="user-profile">
                                {requestedSongsRes?.url}
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="first-user">
                              <div className="user-profile">
                                {requestedSongsRes?.clientRequest?.comment}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="mb-3 comp-pending-drop">
                              <select
                                id={`category`}
                                value={
                                  requestedSongsRes?.requestedSongStatus ||
                                  "Pending"
                                }
                                onChange={(e) =>
                                  handleChange(
                                    requestedSongsRes,
                                    e.target.value
                                  )
                                }
                                className={`form-control ${requestedSongsRes?.requestedSongStatus ===
                                  "Declined" ||
                                  requestedSongsRes?.requestedSongStatus ===
                                  "Pending"
                                  ? "me-4"
                                  : ""
                                  } custom-select`}
                              >
                                <option disabled value="">
                                  Select
                                </option>
                                <option value="Pending">Pending</option>
                                <option value="Approved">Approved</option>
                                <option value="Rejected">Declined</option>
                              </select>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {requestedSongs?.songs?.length == 0 && (
                    <div className="song-requests-data">
                      <div className="no-data-found">
                        <p>No Data</p>
                      </div>
                    </div>
                  )}
                  {/* {requestedSongs?.total > 1 && (
                    <PaginationComponent
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                      totalEntries={totalEntries}
                      entriesPerPage={entriesPerPage}
                    />
                  )} */}
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div className="pb-4">
          <p className="mt-0"></p>
        </div>
      </Container>
      <button className="event-notes-floating-btn" onClick={handleOpenNotesModal}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M5 4.75C5 3.784 5.784 3 6.75 3H17.25C18.216 3 19 3.784 19 4.75V19.25C19 20.216 18.216 21 17.25 21H6.75C5.784 21 5 20.216 5 19.25V4.75Z"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M8.5 8H15.5M8.5 12H15.5M8.5 16H12.75"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
        Notes
      </button>
      <CreateEventModal
        id={eventData?.client?._id}
        show={showModal}
        handleClose={handleCloseEvent}
        selectedEvent={eventData}
        disable={true}
      />
      <DeleteModal
        show={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        handleDelete={handleDeleteEvent}
        name={"Event"}
      />
      <Modal
        show={showNotesModal}
        onHide={handleCloseNotesModal}
        centered
        dialogClassName="event-notes-modal"
      >
        <Modal.Header className="border-none event-notes-modal-header">
          <button
            className="event-notes-close"
            type="button"
            onClick={handleCloseNotesModal}
          >
            x
          </button>
          <div className="event-notes-title-wrap">
            <span className="event-notes-title-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M5 4.75C5 3.784 5.784 3 6.75 3H17.25C18.216 3 19 3.784 19 4.75V19.25C19 20.216 18.216 21 17.25 21H6.75C5.784 21 5 20.216 5 19.25V4.75Z"
                  stroke="currentColor"
                  strokeWidth="1.8"
                />
                <path
                  d="M8.5 8H15.5M8.5 12H15.5M8.5 16H12.75"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              </svg>
            </span>
            <div>
              <Modal.Title>Event Notes</Modal.Title>
              <p>{capitalize(eventData?.client?.fullName) || "Client notes"}</p>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="event-notes-modal-body">
          <div className={`event-notes-card ${isEditingNotes ? "is-editing" : ""}`}>
            {isEditingNotes ? (
              <Form.Control
                as="textarea"
                rows={6}
                value={notesDraft}
                onChange={(e) => setNotesDraft(e.target.value)}
                placeholder="Add useful event notes here..."
                autoFocus
                style={{ border: '0px !important', outline: 'none !important', }}
              />
            ) : (
              <div className="event-notes-display">
                {eventNotes ? (
                  <p>{eventNotes}</p>
                ) : (
                  <div className="event-notes-empty">
                    <strong>No notes added yet</strong>
                    <span>Click edit notes button to write the first note for this event.</span>
                  </div>
                )}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-none event-notes-modal-footer">
          {isEditingNotes ? (
            <>
              <button
                className="secondary"
                type="button"
                onClick={() => {
                  setNotesDraft(eventNotes);
                  setIsEditingNotes(false);
                }}
              >
                Cancel
              </button>
              <button className="primary" type="button" onClick={handleSaveNotes}>
                Done
              </button>
            </>
          ) : (
            <button
              className="primary"
              type="button"
              onClick={() => setIsEditingNotes(true)}
            >
              Edit notes
            </button>
          )}
        </Modal.Footer>
      </Modal>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="border-none justify-content-center">
          <Modal.Title className="mt-3">Create Client</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <div>
            <Form>
              <div className="modal-cmn-form-set">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Full Name*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your Full Name"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Email ID*</Form.Label>
                  <Form.Control type="email" placeholder="Enter your email " />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Estimated Date</Form.Label>
                  <Form.Control type="date" placeholder="Select date" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Notes</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Lorem ipsum dolor sit"
                  />
                </Form.Group>
              </div>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-none justify-content-center">
          <button className="secondary" onClick={handleClose}>
            Close
          </button>
          <button className="primary" onClick={handleClose}>
            Create
          </button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}
